import { PaymentSourceTypeEnum } from "@/shared/ModelEnums";
import BankDetails from "../BankDetails";
import { CardDetailsViewModel } from "../CardDetails";

export default class PaymentSourceModel {
  paymentProviderToken: string = "";
  //   fromDT: DateTime;
  //   toDT: DateTime;
  paymentSourceTypeCd: PaymentSourceTypeEnum = PaymentSourceTypeEnum.PST_BA;
  name: string = "";

  // CC
  numberMask?: string;
  expiryMonth?: string;
  expiryYear?: string;
  type?: string;
  ccv?: string;

  // BA
  bsb?: string;
  number?: string;
}

export function copyCard(cardDetails: CardDetailsViewModel) {
  const paymentSource = new PaymentSourceModel();
  paymentSource.paymentSourceTypeCd = PaymentSourceTypeEnum.PST_CC;
  paymentSource.name = cardDetails.cardholderName;
  paymentSource.numberMask = cardDetails.cardNumber;
  paymentSource.expiryMonth = cardDetails.expiryMonth.toString();
  paymentSource.expiryYear = cardDetails.expiryYear.toString();
  paymentSource.ccv = cardDetails.ccv;
  return paymentSource;
}

export function copyBank(bankDetails: BankDetails) {
  const paymentSource = new PaymentSourceModel();
  paymentSource.paymentSourceTypeCd = PaymentSourceTypeEnum.PST_BA;
  paymentSource.name = bankDetails.bankAccountName;
  paymentSource.bsb = bankDetails.bankAccountBSB;
  paymentSource.number = bankDetails.bankAccountNumber;
  return paymentSource;
}

export class AdministrationPaymentSourceModel extends PaymentSourceModel {
  fromDT: Date = new Date();
  toDT?: Date;
}
